import React from 'react';

const SvgPlay: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fill="#1F1F1F" d="M8 19V5l11 7-11 7Zm2-3.65L15.25 12 10 8.65v6.7Z" />
  </svg>
);

export default SvgPlay;
